import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.auth');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-auth',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.auth/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #f5f5f5;
}

.auth-container {
  max-width: 480px;
  margin: 0 auto;
  min-height: 100%;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
}`],
})
export class LayoutAuthComponent implements OnInit {
    public fontSize: string = 'medium';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.fontSize = localStorage.getItem('app-font-size') || 'medium';
        await this.service.render();
    }
}

export default LayoutAuthComponent;